module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flexContainers",
    attrs: {
      "id": "modal"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wishlist"
  }, [_c('header', {
    staticClass: "wishlist-header"
  }, [_c('i', {
    staticClass: "icon-close",
    on: {
      "click": function($event) {
        _vm.closeModal();
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modalBody"
  }, [_c('p', {
    staticClass: "listTitle"
  }, [_vm._v(_vm._s(_vm.getPlanoName))]), _vm._v(" "), _c('div', {
    staticClass: "list-version"
  }, _vm._l((this.getPlanoVersion), function(version) {
    return _c('div', {
      key: version.id,
      staticClass: "pointer",
      on: {
        "click": function($event) {
          _vm.beforeOpenPlano(version.id, version.objectId, version.version);
        }
      }
    }, [_c('div', {
      staticClass: "content-list"
    }, [_c('div', {
      staticClass: "versionTxt"
    }, [_c('p', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(_vm.$t("versionPlano.version")) + " " + _vm._s(version.version))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("versionPlano.saveBy")) + " " + _vm._s(version.username))])]), _vm._v(" "), _c('div', {
      staticClass: "fright"
    }, [_c('p', {
      staticClass: "versionDate"
    }, [_vm._v(_vm._s(_vm.convertGmtToLocal(new Date(version.loggedAt)).toLocaleString()))])])])])
  }))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44586f47","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planos/modalPlanoVersion.vue
// module id = 3150
// module chunks = 0